import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, tap, catchError } from 'rxjs/operators';
import { AuthService } from '@app-root-services';
import * as authActions from '../actions/auth.actions';
import * as userActions from '../actions/user.actions';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { translationActions } from '../actions';
import { TokenClaims } from '@scf-monorepo/interfaces';

@Injectable()
export class AuthEffects {
    private actions$ = inject(Actions);
    private authService = inject(AuthService);
    private router = inject(Router);

    // Schönere Lösung für das dispatchen von mehreren Actions finden
    login$ = createEffect(() =>
        this.actions$.pipe(
            ofType(authActions.login),
            switchMap(({ authResponse }) =>
                this.authService.getUserData().pipe(
                    switchMap((userData: TokenClaims) => [
                        authActions.loginSuccess({ tokenUserData: userData, authResponse }),
                        userActions.getUser({ gid: userData.gid })
                    ]),
                    catchError(() => of(authActions.tokenExpired()))
                )
            ),
            tap(() => {
                const preAuthUrl = sessionStorage.getItem('pre-auth-url');
                const redirectUrl = preAuthUrl && !preAuthUrl.includes('auth') ? preAuthUrl : '/main';
                if (redirectUrl.includes('?from=') || redirectUrl.includes('&from=')) {
                    const from = redirectUrl.substring(redirectUrl.indexOf('?') + 1);
                    const params = JSON.parse(
                        '{"' + decodeURI(from).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
                    );
                    this.router.navigate(['/main'], { queryParams: params });
                } else {
                    this.router.navigate([redirectUrl]);
                }
            })
        )
    );

    checkTokenSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(authActions.checkToken),
            switchMap(({ authResponse }) =>
                this.authService.getUserData().pipe(
                    switchMap((userData: TokenClaims) => [
                        authActions.loginSuccess({ tokenUserData: userData, authResponse }),
                        userActions.getUser({ gid: userData.gid }),
                        translationActions.getDefaultFileTranslation({ lang: 'en' })
                    ]),
                    catchError(() => of(authActions.tokenExpired()))
                )
            )
        )
    );
}
